import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ThemePreviewKind, ThemePreviewState } from './theme-preview.models';

@Injectable({ providedIn: 'root' })
export class ThemePreviewService {
  private readonly http = inject(HttpClient);

  loadFixture(kind: ThemePreviewKind): Observable<ThemePreviewState> {
    const fixtureUrl = new URL(`/theme-preview-fixtures/${kind}.json`, window.location.origin).toString();
    return this.http.get<ThemePreviewState>(fixtureUrl);
  }
}
